import { Role } from '../catalogs/roles/services/role';
import {
  ComponentType,
  FormStatusEnum,
  ReturnType,
  Roles,
} from 'src/app/common/enumerations/enumerations';
import { Annotation, ChecklistExecStatus } from '../checklists/checklists';
import { ActionItem } from 'src/app/common/models/action-item';
import { Tooltip } from 'src/app/common/tooltip';
import { utils } from 'src/app/modules/libs/utils';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { User } from '../catalogs/user-catalog/services/user';
import { ReviewSatisfactionCheck } from '../reviews/reviews.models';
import { SCFHoldPointResource } from '../scf-v2/scf';
import { FormStatus } from 'src/app/services/forms/form-status';
import { RSFHoldPoint } from '../rsf/rsf';
import { ResourceBaseV2 } from 'src/app/common/models/model-base';
import { WFError } from '../checklists/checklist-builder/checklist-builder.component';

export class WFTableResource {
  id!: number;
  name!: string;
  formType!: number;
  formName!: string;
  statusName!: string;
  description!: string;
  type!: number;
  status!: number;
  code!: string;
  createdBy?: number;
  createdByName!: string;
  createdOn!: Date;
  updatedBy?: number;
  updatedByName!: string;
  updatedOn!: Date;
  approvedBy?: number;
  approvedByName?: string;
  approvedOn?: Date;
  wfTableLocalID?: number;
  wfTableLocal?: WFTableLocalResource;
  sections!: WFMasterResource[];
  documentTypeID?: number;
}

export class WFTableLocalResource {
  id!: number;
  name!: string;
  wfSectionLocals!: WFSectionLocalResource[];
  wfTableConfiogID?: number;
  wfTableConfig?: WFTableConfig;
  hashCode!: string;
}
export class WFTableConfig {
  constructor() {
    this.wfSectionConfigs = [];
  }
  id!: number;
  name!: string;
  formType!: number;
  formName?: string;
  description?: string;
  code?: string;
  type!: number;
  status!: number;
  statusName?: string;
  createdBy?: number;
  createdByName?: string;
  createdOn?: string;
  updatedBy?: number;
  updatedByName?: string;
  updatedOn?: string;
  approvedBy?: number;
  approvedOn?: string;
  approvedByName?: string;
  wfSectionConfigs?: WFSectionConfig[];
}
export class WFMasterResource {
  id!: number;
  form!: number;
  identificator!: number;
  sectionName!: string;
  description!: string;
  type!: number;
  status!: number;
  code!: string;
  createdByName!: string;
  createdOn!: Date;
  updatedByName!: string;
  updatedOn!: Date;

  wfTableConfigID!: number;
  wfSectionConfigID!: number;
  wfTaskConfigID!: number;
  wfStepConfigID!: number;
  steps!: WFStepConfig[];

  expanded?: boolean;
  logID?: number;
}

export interface WFStepConfig {
  id: number;
  name?: string;
  start: boolean;
  end: boolean;
  statusId?: number;
  statusName?: string;
  description?: string;
  type?: number;
  status?: number;
  code?: string;
  createdBy?: number;
  createdByName?: string;
  createdOn?: Date;
  updatedBy?: number;
  updatedByName?: string;
  updatedOn?: Date;
  // wfTableConfigID?: number;
  wfSectionConfigID?: number;
  iterable?: boolean;
  collapsible?: boolean;
  collapsed?: boolean;
  wfIterationSourceID?: number;
  wfTaskConfigs?: WFTaskConfig[];
  logID?: number;
  order?: number;
  wfStepStatusConfigs?: WFStepStatusConfig[];
  avoidUnapprove?: boolean;
  wfIterationSource: WFIterationSource;
  wfSectionConfig: WFSectionConfig;
  wfTableConfig: WFTableConfig;
  samePersonApprove?: boolean;
  restrictSubmitter?: boolean;
  fullWidth?: boolean;

  // Internal
  selectedStatuses?: FormStatusEnum[];
}

export interface WFStepStatusConfig {
  id: number;
  wfStepConfigID: number;
  status: FormStatusEnum;
  formStatus?: FormStatus;
}

export interface WFIterationSource {
  id: number;
  name: string;
  description: string;
  status: number;
  type: number | null;
  code: string;
  createdOn: string;
  createdBy: number;
  updatedOn: string | null;
  updatedBy: number | null;
}

export interface WFSectionConfig extends ResourceBaseV2 {
  id: number;
  number: number;
  name: string;
  order: number;
  wfTableConfigID: number;
  wfStepConfigs: WFStepConfig[];
}

export interface WFTaskConfig {
  id?: number;
  name?: string | null;
  name2?: string | null;
  name3?: string | null;
  name4?: string | null;
  required?: boolean;
  order?: number;
  enabled?: boolean;
  condition?: string;
  description?: string;
  type?: number;
  status?: number;
  code?: string;
  createdBy?: number;
  createdByName?: string;
  createdOn?: string;
  updatedBy?: number;
  updatedByName?: string;
  updatedOn?: string;
  wfStepConfigID?: number;
  wfActionConfigs?: WFActionConfig[];
  wfRoleConfigs?: WFRoleConfig[];
  options?: string;
  configuration?: string;
  component?: WFComponent;
  statusName?: string;
  requesterSignature?: boolean;
}

export interface WFActionConfig {
  id?: number;
  name: string;
  label: string;
  action: number;
  description?: string;
  type?: number;
  status?: number;
  code?: string;
  createdByName?: string;
  createdOn?: Date;
  updatedByName?: string;
  updatedOn?: Date;
  wfTaskConfigID?: number;
  wfNextStepConfigID?: number;
}

export interface WFRoleConfig {
  id: number;
  roleID: number;
  role?: Role;
  roleName?: string;
  roleCode?: string;
  description?: string;
  type?: number;
  status?: number;
  code?: string;
  createdByName?: string;
  createdOn?: Date;
  updatedByName?: string;
  updatedOn?: Date;
  wfTaskConfigID: number;
}

export class ReorderResource {
  id!: number;
  order!: number;
}

export class WFComponent {
  id!: number;
  name!: string;
  description!: string;
  status!: number;
  type!: number;
  code?: string;
  createdOn!: Date;
  createdBy!: number;
  updatedOn?: Date;
  updatedBy?: number;
  numericHeader?: boolean;
  hasRadioButtons?: boolean;
  hasMultipleCheckboxes?: boolean;
  hasMultipleTextboxes?: boolean;
  hasMultipleRoles?: boolean;
  textFields?: number;
  colorize?: boolean;
  needActions?: boolean;
  needRoles?: boolean;
  hasConditions?: boolean;
  hasSigConditions?: boolean;
  hasTag?: boolean;
  defaultTag?: string;
  returnType?: ReturnType;
  helpText?: string;
  fullWidth?: boolean;
}

export enum WFStatus {
  New = -1,
  Inactive = 0,
  Active = 1,
  'Pending Approval' = 2,
}

export class WfActionLocalResource {
  id?: number;
  name?: string;
  label?: string;
  wfActionConfigID?: number;
  action?: number;
  wfTaskLocalID?: number;
  wfNextStepLocalID?: number;
  subAction?: number;
  nextStatusID?: number | null;
  nextStatus?: ChecklistExecStatus;
}
export class WfTaskLocalResource {
  id?: number;
  name!: string;
  description?: string;
  status?: number;
  type?: number | null;
  code?: string;
  createdOn?: string;
  createdByID?: number | null;
  createdBy?: User;
  updatedOn?: string | null;
  updatedByID?: number | null;
  updatedBy?: User;

  name2?: string | null;
  name3?: string | null;
  name4?: string | null;
  value?: boolean;
  numericValue?: number;
  doubleValue?: number;
  text?: string | null;
  enabled?: boolean;
  order?: number;
  wfTaskConfigID?: number;
  wfActionLocals?: WfActionLocalResource[];
  wfRoleLocals?: WFRoleLocal[];
  wfUserLocals?: WFUserLocal[];
  wfTasks?: WfTaskResource[];
  wfStepLocalID?: number;
  wfStepLocal?: WFStepLocalResource;
  scheduleResourceId?: number;
  scheduleType?: number;
  resourceId?: number;
  resourceName?: string | null;
  configuration?: string;
  condition?: string;
  sigCondition?: string;
  options?: string;
  componentID?: number;
  component?: WFComponent;
  hashCode?: string;
  disabled?: boolean;
  reviewSatisfactionChecks?: ReviewSatisfactionCheck[];
  booleanValue?: boolean;
  amendmentID?: number;
  scfHoldPointID?: number;
  scfHoldPoint?: SCFHoldPointResource;
  rsfHoldPointID?: number;
  rsfHoldPoint?: RSFHoldPoint;
  rsfAmendmentHoldPointID?: number;
  rsfAmendmentHoldPoint?: RSFHoldPoint;
  requesterSignature?: boolean;
  required?: boolean;
  annotations?: Annotation[];
  isCompleted?: boolean;
  isTouched?: boolean;

  // Checklist Builder Undo Feature Properties
  logID?: number;
  checklistTemplateID?: number;
  itemCount?: number;
  errors?: WFError[];
  previousTasksCompleted?: boolean;
  sigConditionResult?: boolean;
}

export interface WFSectionLocalResource {
  id: number;
  number?: number;
  name?: string;
  description?: string;
  code?: string;
  type?: number;
  status?: WFSectionLocalStatus;
  order?: number;
  wfTableID?: number;
  wfTableLocalID?: number;
  wfSectionConfigID?: number;
  actionItems?: ActionItem[];
  collapsible?: boolean;
  collapsed?: boolean;
  wfStepLocals?: WFStepLocalResource[];
  wfSignatures?: WfSignatureResource[];
  createdBy?: User;
  createdOn?: Date;
  updatedBy?: User;
  updatedOn?: Date;
  configuration?: string;

  // Checklist Builder Undo Feature Properties
  logID?: number;
  checklistTemplateID?: number;
  errors?: WFError[];
}

export class WFStepLocalResource {
  id!: number;
  name!: string;
  description!: string;
  type!: number;
  status!: WFStepLocalStatus;
  start!: boolean;
  end!: boolean;
  order!: number;
  code!: string;
  collapsible?: boolean;
  collapsed?: boolean;
  avoidUnapprove!: boolean;
  wfSectionLocalID!: number;
  wfSectionLocal!: WFSectionLocalResource;
  wfTaskLocals!: WfTaskLocalResource[];
  wfStepStatusLocals!: WFStepStatusLocal[];
  createdBy!: User;
  createdOn!: Date;
  updatedBy!: User;
  updatedOn!: Date;
  wfSteps!: WFStep[];
  wfStepConfig!: WFStepConfig;
  configuration?: string;
  samePersonApprove?: boolean;
  restrictSubmitter?: boolean;
  fullWidth?: boolean;

  // Internal
  active?: boolean;
  signatures?: WfSignature[];

  // Checklist Builder Undo Feature Properties
  logID?: number;
  checklistTemplateID?: number;
  number?: number;
  visible?: boolean;
  errors?: WFError[];
}

export class WFStep {
  id!: number;
  name!: string;
  start!: boolean;
  end!: boolean;
  wfTableID!: number;
  active!: boolean;
  wfStepLocalID!: number;
  status!: FormStatusEnum;
  wfAmmendmentID?: number;
}

export interface WFStepStatusLocal {
  id: number;
  wfStepLocalID: number;
  status?: FormStatusEnum;
  checklistExecStatus?: ChecklistExecStatus;
  hidden: boolean;
  enabled: boolean;
  cssClass: string;
}

export class SaveTaskResource {
  id!: number;
  value?: boolean;
  numericValue?: number;
  text?: string | null;
  doubleValue?: number | null;
  field?: string;
  formType?: number;
  option?: number;
  resourceId?: number;
  answerChangedById?: number | null;
  disabled?: boolean;
  booleanValue?: boolean;
  isCompleted?: boolean;
  pendingChange?: boolean;
  pendingChangeObj?: string | null;
  updatedOn?: string | null;
}

export class WfTaskResource {
  id?: number;
  name?: string;
  required?: boolean;
  order?: number;
  enabled?: boolean;
  signedOn?: Date;
  signedBy!: sign | null;
}

export class WFTaskSignatureResource {
  taskId?: number;
  actionId?: number;
  reason?: string | null;
  formID?: number;
  amendment?: boolean;
  options?: string;
  status?: FormStatusEnum;
}

export class WFConfiguration {
  ID?: number;
  form?: number;
  identificator?: number;
  wfSectionLocalID?: number;
  wfTaskLocalID?: number;
  wfTableID?: number;
}

export class WfSignatureResource {
  amendmentID!: number;
  order?: number;
  id!: number;
  code?: string;
  condition?: string;
  taskID!: number;
  titleBefore!: string;
  titleAfter!: string;
  titleAfter2!: string;
  enabled?: boolean;
  required?: boolean;
  visible?: boolean;
  question!: string;
  signed!: boolean;
  signedBy?: User | null;
  signedOn!: Date | null;
  roles!: Role[];
  users!: User[];
  approveID!: number;
  unapproveID?: number;
  disapproveID?: number;
  cancelID?: number;
  approveEnabled!: boolean;
  unapproveEnabled!: boolean;
  disapproveEnabled!: boolean;
  disapproveReason!: string;
  amendmentEnabled!: boolean;
  cancelEnabled!: boolean;
  value!: boolean;
  text!: string;
  type!: number;
  options!: string;
  numericValue?: number;
  doubleValue!: number | null;
  wfTaskConfigID?: number;
  wfTaskLocal!: WfTaskLocalResource;
  sectionNumber!: number;
  sectionName!: string;
  iterable!: boolean;
  status!: number;
  warning!: boolean;
  moreInfo?: string | null;
  locationMoreInfo?: string | null;
  radSurveyRequiredForms?: string | null;
  disabled?: boolean;
  testSignReady?: boolean;
  radioDisabled?: boolean;
  amendmentNumber?: number;
  resourceId?: number;
  scheduleResourceId?: number;
  scheduleType?: number;
  dateValue1?: Date;
  dateValue2?: Date;
  dateValue3?: Date;
  scheduleName?: string;
  locationName?: string;
  answerChangedBy?: User;
  answerChangedById?: number;
  requesterSignature?: boolean;
  component?: WFComponent;
  configuration?: string;
  extraActions!: ExtraAction[];
  followUpChanged?: boolean;
  lastFollowUpChanged?: string;
  lastFollowUpCheckChanged?: string;
  privilegeToApproveChanges?: PrivilegeEnum;
  holdPointID?: number;
  amendmentHoldPointID?: number;
  isCompleted?: boolean;
  pendingChange?: boolean;
  pendingChangeObj?: string;
  formStatuses?: FormStatusEnum[];
  stepOrder?: number;
  sortOrder: any;
  checkboxDisabled?: boolean;
  wfAmendmentID?: number;
  hilite?: boolean;

  public static transformSignature(
    signature: WfSignatureResource,
    disabled?: boolean,
    overrideDisabledStep?: boolean,
    currentUser?: User | null): WfSignature {

    let taskDisabled = disabled || !signature.enabled || signature.disabled;
    if (!overrideDisabledStep && !signature.requesterSignature) {
      taskDisabled = taskDisabled || !(signature.approveEnabled || signature.unapproveEnabled);
    }
    if (signature.users?.length) {
      taskDisabled = taskDisabled || !signature.users?.some(u => u.id == currentUser?.id);
      signature.approveEnabled = !taskDisabled && !!signature.approveID;
    }
    else if (signature.wfTaskLocal.wfRoleLocals?.length) {
      taskDisabled = taskDisabled || !signature.wfTaskLocal.wfRoleLocals?.some(r => currentUser?.userRole?.some(ur => ur.roleID == r.roleID));
    }

    // const configuration = utils.JSONparse(signature.configuration);
    // const showIfNotEnabled = !configuration?.hideDisable;
    // const visible = !signature.enabled ? showIfNotEnabled : signature.visible;

    const can = (flag: boolean) => !taskDisabled && (overrideDisabledStep || flag);

    return {
      id: signature.id,
      name: signature.titleBefore,
      question: signature.question,
      titleAfter: signature.titleAfter,
      code: signature.code,
      type: !signature.type ? ComponentType.ButtonSignature : signature.type,

      //Actions
      approved: signature.signed,
      approvedBy: signature.signedBy,
      approvedOn: signature.signedOn,

      approveAction: can(signature.approveEnabled) && !!signature.approveID,
      approveActionId: signature.approveID,

      unapproveAction: can(signature.unapproveEnabled) && !!signature.unapproveID,
      unapproveActionId: signature.unapproveID,

      disapproveAction: can(signature.disapproveEnabled) && !!signature.disapproveID,
      disapproveActionId: signature.disapproveID,

      amendment: signature.amendmentEnabled,
      amendmentId: signature.amendmentID,
      amendmentAction: signature.amendmentEnabled,
      amendmentActionId: signature.amendmentID,
      amendmentNumber: signature.amendmentNumber,
      wfAmendmentID: signature.wfAmendmentID,

      cancelAction: signature.cancelEnabled,
      cancelActionId: signature.cancelID,
      cancelID: signature.cancelID,
      cancel: signature.cancelEnabled,


      //Permissions
      roles: signature.roles.map(r => r.id as number),
      roleCodes: signature.roles.map(r => r.code).join('/'),
      userNames: signature.users?.map(user => user?.name).join('/'),

      disabled: taskDisabled,
      required: signature.required,
      enabled: signature.enabled,
      visible: signature.visible,
      checkboxDisabled: signature.checkboxDisabled,

      //Properties
      value: signature.value,
      text: signature.text,
      textValue: signature.text,
      warning: signature.warning,
      options: utils.JSONparse(signature.options),
      isCompleted: signature.isCompleted,
      configuration: signature.configuration,
      condition: signature.condition,
      moreInfo: signature.moreInfo ?? undefined,
      locationMoreInfo: signature.locationMoreInfo ?? undefined,
      requesterSignature: signature.requesterSignature,
      numericValue: signature.numericValue,
      doubleValue: signature.doubleValue,
      dateValue1: signature.dateValue1,

      //Workflow
      taskId: signature.taskID,
      wfTaskLocal: signature.wfTaskLocal,
      stepNumber: signature.wfTaskLocal.wfStepLocal!.order + 1,
      stepName: signature.wfTaskLocal.wfStepLocal!.name,
      sectionName: signature.sectionName,
      sectionNumber: signature.sectionNumber,
      // Non-prod tester tooling: role/user-independent "is it this signature's turn?" (backend).
      // Needed by the RSF "Tester Approve" gating; omitting it here would leave it always undefined.
      testSignReady: signature.testSignReady,
      iterable: signature.iterable,
      holdPointID: signature.holdPointID,
      amendmentHoldPointID: signature.amendmentHoldPointID,

      //FollowUp
      answerChangedBy: signature.answerChangedBy,
      answerChangedById: signature.answerChangedById,
      followUpChanged: signature.followUpChanged,
      lastFollowUpChanged: signature.lastFollowUpChanged,
      lastFollowUpCheckChanged: signature.lastFollowUpCheckChanged,
      pendingChange: signature.pendingChange,
      pendingChangeObj: signature.pendingChangeObj,
      privilegeToApproveChanges: signature.privilegeToApproveChanges,

      //General
      hilite: signature.hilite

    };
  }
}


export interface WfSignature {
  id?: number;
  number?: string | null;
  taskId?: number;
  name?: string | null;
  disabled?: boolean;
  disableEdit?: boolean;
  required?: boolean;
  visible?: boolean;
  question?: string | null;
  question2?: string | null;
  question3?: string | null;
  approved?: boolean;
  approvedBy?: User | null;
  approvedOn?: Date | null;
  roles?: number[] | null;
  roleCodes?: string;
  userNames?: string;
  amendment?: boolean;
  value?: boolean;
  value2?: number;
  textValue?: string | null;
  type?: number;
  options?: any[];
  sectionName?: string;
  sectionNumber?: number;
  stepNumber?: number;
  stepName?: string;
  iterable?: boolean;
  order?: number;
  cancelID?: number;
  cancel?: boolean;
  isVacuum?: boolean;
  warning?: boolean;
  moreInfo?: string;
  locationMoreInfo?: string;
  RadSurveyRequiredForms?: string;
  resourceId?: number;
  scheduleResourceId?: number;
  scheduleTypeId?: number;
  numericValue?: number;
  doubleValue?: number | null;
  dateValue1?: Date;
  dateValue2?: Date;
  dateValue3?: Date | null;
  scheduleName?: string;
  locationName?: string | null;
  editMode?: boolean;
  condition?: string;
  sigCondition?: string;
  code?: string;
  enabled?: boolean;
  testSignReady?: boolean;
  component?: WFComponent;
  configuration?: string;
  requesterSignature?: boolean;
  answerChangedBy?: User;
  answerChangedById?: number;
  text?: string | null;
  titleAfter?: string;
  status?: number;
  stepId?: number;
  followUpChanged?: boolean;
  lastFollowUpChanged?: string;
  lastFollowUpCheckChanged?: string;
  privilegeToApproveChanges?: PrivilegeEnum;
  booleanValue?: boolean;
  holdPointID?: number;
  amendmentHoldPointID?: number;
  isCompleted?: boolean;
  wfTaskLocal?: WfTaskLocalResource;
  cssClass?: string;
  pendingChange?: boolean;
  pendingChangeObj?: string;
  amendmentId?: number;
  amendmentNumber?: number;
  wfAmendmentID?: number;

  //#region Actions
  approveAction?: boolean;
  approveActionId?: number;
  unapproveAction?: boolean;
  unapproveActionId?: number;
  disapproveAction?: boolean;
  disapproveActionId?: number;
  amendmentAction?: boolean;
  amendmentActionId?: number;
  cancelAction?: boolean;
  cancelActionId?: number;
  //#end Actions

  invalid?: boolean;
  errors?: string;
  tooltips?: Tooltip[];
  color?: string;
  checkboxDisabled?: boolean;
  radioDisabled?: boolean;

  approveNextStepConfigID?: number;
  unapproveNextStepConfigID?: number;
  disapproveNextStepConfigID?: number;
  amendmentNextStepConfigID?: number;
  cancelNextStepConfigID?: number;

  formStatuses?: FormStatusEnum[];

  // internal
  _dirty?: boolean;
  hilite?: boolean;
  previousTasksCompleted?: boolean;
  isShielding?: boolean;
}

class sign {
  id?: number | null;
  name?: string | null;
  initials?: string | null;
}

export class WFRoleLocal {
  id!: number;
  role?: Role;
  roleID!: number;
  roleCode?: string;
  wfTaskLocalID!: number;
  wfRoleConfigID?: number;
}

export interface WFUserLocal {
  id: number;
  userID: number;
  wfTaskLocalID: number;
  wfUserConfigID: number;
  roleID: number;
  user: User | null;
}

// tslint:disable-next-line: class-name
// class role {
//   id!: number;
//   name!: string;
//   code!: string;
// }

export class ExtraAction {
  public id!: number;
  public taskID!: number;
  public name!: string;
}

export enum WFStepLocalStatus {
  NONE = 0,
  DUPLICATED = 1,
}

/**
 * Represents the local status of a workflow section.
 *
 * @remarks
 * This enum is used to indicate the current local state of a workflow section,
 * such as whether it has no special status or is marked as duplicated.
 *
 * @enum {number}
 * @property {number} NONE - Indicates that the workflow section has no special status.
 * @property {number} DUPLICATED - Indicates that the workflow section is duplicated.
 */
export enum WFSectionLocalStatus {
  NONE = 0,
  DUPLICATED = 1,
}

export enum WFAction {
  Extra = 0,
  Approve = 1,
  Disapprove = 2,
  Unapprove = 3,
  Amendment = 4,
  Cancel = 5,
  Close = 6,
  Update = 0
}
